import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `grouping_table` component.
 * Keep in sync with GroupingTableProps in src/ui/uiConfig/components/GroupingTable/GroupingTable.types.ts
 */
export const groupingTablePropDocs: ComponentDocMap = {
  base_items: {
    description: 'Controls whether the component uses all items from base_config.',
    type: '{ all: boolean }',
    example: '{ "all": true }',
  },
  'base_items.all': {
    description: 'When true, include all base_config items before filtering.',
    type: 'boolean',
    example: 'true',
  },
  items: {
    description: 'Explicit items used when not relying only on base_items.',
    type: 'UiConfigPropsItem[]',
    example: '[{ title: "__Boiler A", data_id: "boiler_a", unit: "MW" }]',
  },
  title: {
    description: 'Title displayed above the grouping table.',
    type: 'string',
    example: '"__Grouped production"',
  },
  grouping_tag: {
    description: 'Tag key used to group rows (e.g. fuel, area, unit type).',
    type: 'string',
    example: '"fuel"',
  },
  hide_items_including_tag: {
    description: 'Rows with any matching tag value are hidden from the table.',
    type: 'string[]',
    example: '["waste"]',
  },
  columns: {
    description: 'Column definitions describing which map fields to display.',
    type: 'GroupingTableColumn[]',
    example: '[{ title: "__Output", map_id: "power", unit: "MW" }]',
  },
  'columns[].title': {
    description: 'Column display title.',
    type: 'string',
  },
  'columns[].map_id': {
    description: 'Key used to map values from item metadata/datasets.',
    type: 'string',
  },
  'columns[].unit': {
    description: 'Unit label shown for this column.',
    type: 'string',
  },
  'columns[].include_item_unit': {
    description: 'Append each item unit in addition to the column unit.',
    type: 'boolean',
  },
}
